import React, { Component } from 'react';
import { Link } from 'react-router';
import './footer.scss';

export default class Footer extends Component {

  contactUs(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    dataLayer.push({
      event: 'contactUs'
    })
  }

  render () {
    return (
      <footer className="footer">
        <div className="container">
          <div>&copy; {new Date().getFullYear()} <Link to="/termsAndConditions">Terms & Conditions</Link>
            {' | '} <Link to="/dataUsage">Data Usage Policy</Link>
            {' | '} <a href="http://help.planetprotectoracademy.com"  target="_blank">Help & Support</a>
            {' | '} <a onClick={::this.contactUs}>Contact Us</a>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/footer.jsx